import { Phone, Mail, MapPin, Clock, MessageCircle, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { COMPANY } from "@/data/content";

export default function Contacto() {
  const wa = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent("Hola Colnexx, necesito ayuda.")}`;
  const channels = [
    { icon: MessageCircle, title: "WhatsApp", value: COMPANY.whatsappDisplay, href: wa, cta: "Abrir chat" },
    { icon: Phone, title: "Línea de atención", value: COMPANY.phone, href: `tel:${COMPANY.phone.replace(/\s/g, "")}`, cta: "Llamar" },
    { icon: Mail, title: "Correo electrónico", value: COMPANY.email, href: `mailto:${COMPANY.email}`, cta: "Escribir" },
  ];

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-12" data-testid="contacto-page">
      <div className="mb-10">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">Estamos para ayudarte</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-2">Canales de contacto</h1>
        <p className="text-muted-foreground mt-3 max-w-2xl">Comunícate con Colnexx por el canal que prefieras. Nuestro equipo de atención está disponible para resolver tus inquietudes.</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-12">
        {channels.map((c) => (
          <div key={c.title} className="rounded-3xl border border-border bg-card p-8 flex flex-col" data-testid={`contact-${c.title.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="h-14 w-14 rounded-2xl bg-accent grid place-items-center mb-5"><c.icon className="h-7 w-7 text-primary" /></div>
            <h3 className="font-display text-xl font-bold">{c.title}</h3>
            <p className="text-muted-foreground mt-1 mb-6 flex-1">{c.value}</p>
            <a href={c.href} target="_blank" rel="noopener noreferrer"><Button className="w-full rounded-full font-semibold">{c.cta}</Button></a>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="rounded-3xl border border-border bg-card p-8 space-y-5">
          <h2 className="font-display text-2xl font-bold">Información de la empresa</h2>
          <div className="flex items-start gap-3"><MapPin className="h-5 w-5 text-primary mt-0.5" /><div><div className="font-semibold text-sm">Dirección</div><div className="text-muted-foreground text-sm">{COMPANY.address}</div></div></div>
          <div className="flex items-start gap-3"><Clock className="h-5 w-5 text-primary mt-0.5" /><div><div className="font-semibold text-sm">Horario de atención</div><div className="text-muted-foreground text-sm">{COMPANY.hours}</div></div></div>
          <div className="flex items-start gap-3"><FileText className="h-5 w-5 text-primary mt-0.5" /><div><div className="font-semibold text-sm">Razón social</div><div className="text-muted-foreground text-sm">{COMPANY.legal} · NIT {COMPANY.nit}</div></div></div>
        </div>
        <div className="rounded-3xl bg-secondary text-secondary-foreground p-8 grain relative overflow-hidden flex flex-col justify-center">
          <div className="absolute -top-10 -right-10 h-48 w-48 rounded-full bg-primary/30 blur-3xl" />
          <div className="relative">
            <h2 className="font-display text-2xl font-bold mb-3">¿Tienes una petición, queja o reclamo?</h2>
            <p className="text-secondary-foreground/70 mb-6">Radícala en línea y recibe tu constancia de inmediato con número de radicado y plazo de respuesta.</p>
            <Link to="/pqr"><Button size="lg" className="rounded-full font-semibold">Radicar PQR</Button></Link>
          </div>
        </div>
      </div>
    </div>
  );
}
